import axios from 'axios';
import { logoutUnAuthenticat } from './auth';

// Check if error message indicates token expiration
const isTokenExpiredError = (error: any): boolean => {
  // Check various possible error message locations
  const errorMessage = error?.response?.data?.message ||
    error?.message ||
    error?.data?.message ||
    error?.message ||
    (typeof error === 'string' ? error : '');

  if (!errorMessage) return false;

  const messageStr = String(errorMessage).toLowerCase();
  return (
    messageStr.includes('access token has expired') ||
    messageStr.includes('token has expired') ||
    messageStr.includes('token expired') ||
    messageStr.includes('please verify again') ||
    messageStr.includes('invalid or expired access token') ||
    messageStr.includes('expired access token')
  );
};

// Handle token expiration by logging out
const handleTokenExpiration = () => {
  logoutUnAuthenticat(() => {
    window.location.href = '/timesheet/login';
  });
};

export const addTimeSheet =
  (data): any =>
    async () => {
      const response = await axios.post(
        `${process.env.API_URL}/timesheet/add`,
        data
      );
      return response.data;
    };

export const getTimeSheet =
  (date, userId): any =>
    async () => {
      const response = await axios.post(
        `${process.env.API_URL}/timesheet/get/?date=` + date,
        { userId }
      );
      return response.data.data;
    };

export const getUserList =
  (date): any =>
    async () => {
      const response = await axios.get(
        `${process.env.API_URL}/timesheet/get/userlist/?date=` + date
      );
      return response.data.data;
    };

export const getData =
  (url, query = {}, options: any = {}): any =>
    async () => {
      try {
        const baseURL = options?.baseURL || process.env.API_URL;
        const response = await axios.get(`${baseURL + url}`, {
          params: query
        });
        return response.data;
      } catch (error: any) {
        // Check if token expired
        if (isTokenExpiredError(error) || error?.response?.status === 401) {
          handleTokenExpiration();
          return { code: 401, message: 'Access token has expired. Please verify again.' };
        }
        throw error;
      }
    };

export const getDataBy =
  (url): any =>
    async () => {
      const response = await axios.get(`${process.env.API_URL + url}`);
      return response.data;
    };

export const deleteRow =
  (url): any =>
    async () => {
      const response = await axios.delete(`${process.env.API_URL + url}`);
      return response.data;
    };

export const uploadFile = async (path, params) => {
  try {
    const response = await axios.post(`${process.env.API_URL + path}`, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (response.status >= 200 && response.status < 300) {
      return await response.data;
    } else {
      throw new Error(`${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};